import React, { useCallback, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import MainLayout from '../../layouts/MainLayout';

import PaintCanvas from './PaintCanvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPalette } from '@fortawesome/free-solid-svg-icons';
import './NotesCanvas.css';

const GeographyCanvas = () => {
  const authState = useSelector(state => state.authReducer);
  const userId = authState.user._id
  const [fetchData, { loading }] = useFetch();
  const [overlayContent, setOverlayContent] = useState(null);
  const [touchBooks, setTouchBooks] = useState([]);
  const [selectedBook, setSelectedBook] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchTouchBooks();
  }, []);

  const fetchTouchBooks = useCallback(() => {
    const config = {
      url: "/touchbook/category",
      method: "post",
      headers: { Authorization: authState.token },
      data: {category: "Children"}
    };
    // console.log("config:", config);


    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Response:", response);
        if (response) {
          // console.log("Response in array:", response);
          setTouchBooks(response.touchbooks);
        } else {
          console.error("Invalid response format: Touchbooks not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching Touchbooks:", error);
      });
  }, [authState.token, fetchData]);

  const handleItemClick = (myImage) => {
    setOverlayContent(() => <PaintCanvas imageSrc={myImage} onClose={handleCloseOverlay} />);
  };

  const handleCloseOverlay = () => {
    setOverlayContent(null);
  };

  const handleBackToHome = () => {
    navigate('/touchbook-home');
  };

  const handleBookSelect = (book) => {
    setSelectedBook(book);
  };

  return (
    <div className="full-screen-overlay">
      <div className='flex flex-col'>
        <div className='flex justify-center items-center my-4'>
          <p className='text-white bg-lime-800 text-xl font-semibold rounded-lg px-6 py-2 shadow-lg'>
            <FontAwesomeIcon className="text-lime-400" icon={faPalette} size="200x" />
            Your Digital Coloring Exercise Books
          </p>
        </div>

        <div className='flex justify-center my-4'>
          <label htmlFor="book-dropdown" className='text-white'>Select a Book:</label>
          <select
            id="book-dropdown"
            onChange={(e) => handleBookSelect(touchBooks.find(book => book._id === e.target.value))}
            className='dropdown'
          >
            <option value="">-- Select a Book --</option>
            {touchBooks.map(book => (
              <option key={book._id} value={book._id}>
                {book.title}
              </option>
            ))}
          </select>
        </div>

        {selectedBook && (
          <div className="book-list">
            <div className="book-item">
              <button
                onClick={() => handleItemClick(selectedBook._id)}
              >
                <img src={selectedBook.thumbnail} alt={selectedBook.title} className="book-thumbnail" />
              </button>
              <p className="book-title">{selectedBook.title}</p>
            </div>
            <div 
            >
          </div>
          </div>
        )}
        <div className='grid grid-cols-3 grid-rows-2 gap-x-2 gap-y-1 justify-center '>
          <button onClick={() => handleItemClick('nature')}>Nature</button>
          <button onClick={() => handleItemClick('city')}>City</button>
          <button onClick={() => handleItemClick('map')}>Map</button>
          <button className="ml-8 bg-blue-500" onClick={handleBackToHome}>Close</button>
        </div>
      </div>

      {overlayContent && (
        <div className="overlay">
          {overlayContent}
        </div>
      )}
    </div>
  );
};

export default GeographyCanvas;
